// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1ZE1w","title":"Images45_title__3-iNJ","images":"Images45_images__2NBFI"};